// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDFJmtKtK-Q-lpTAhuw9dforwavkYXJMaU",
    authDomain: "rosymartiapp.firebaseapp.com",
    databaseURL: "https://rosymartiapp.firebaseio.com",
    projectId: "rosymartiapp",
    storageBucket: "",
    messagingSenderId: "601323419133"
  }
};
